import React from 'react'
import getSymbolFromCurrency from 'currency-symbol-map'
import popup from '../../../popup'
import { format } from "date-fns";
import './style.css'

class ThankYou extends React.Component {
  componentDidMount(){
    document.getElementsByClassName('hidden-input')[0].focus()
  }
  render() {
    var plan = this.props.plan
    var pd = plan.planDetails[0]
    
    return (
      <div className="thank-you-screen">
        <input type="text" className="hidden-input" readOnly="readonly"/>
        <div className="title">Thank You for subscribing!</div>
        {this.props.firstPayment && <div className="desc">
          <span className="first-payment">First Payment</span>
          <span className="price">
            &nbsp;
              {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
            {this.props.firstPayment.amount.toFixed(2)}
          </span> (+ tax if req'd) on {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
        </div>}
        <div className="order-details">
          { this.props.plan.name } <strong>{ /*getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)*/ }{ /*pd.recurringPaymentAmount*/ }</strong> <br/>
          Email: { this.props.user.email }
        </div>
        <div className="help">
          {window.settings.customerService && window.settings.customerService.email &&
            <p>
              <a className="link" href={`mailto:${window.settings.customerService.email}`}>
                Contact Us
              </a>
              if you need help.
              <br/>
            </p>
          }
          Visit your <a className="link" href="/user/account">Account Page</a> to see your billing information.
        </div>
        <div className="button site-background-color" onClick={ _ => popup.hide() }>
          Close
        </div>
      </div>
    )
  }
}

export default ThankYou;
